import React from "react"
import { ISearchValue, SearchTypeEnum } from "../../../../components2/YhPageHeader/Types";
import { YhPageHeader } from "../../../../components2/YhPageHeader";
import { useCustomerModel } from "../customerModel"
import useMdmModel from "../../../../model/mdmModel"

export function SearchForm() {
    const {
        searchParam,
        upDataSearchParam,
        resetSearchParam,
        loadData
    } = useCustomerModel();
    const {mdmCatalog,mdmBranch,mdmSourceApp,shop,userAll} = useMdmModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "分支编码",
            fieldName: "branch",
            size: "small",
            disabled: false,
            options: mdmBranch
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "关联门店",
            fieldName: "shopCode",
            size: "small",
            disabled: false,
            options:shop
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "关联用户",
            fieldName: "userCode",
            size: "small",
            disabled: false,
            options:userAll
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "客户编码",
            fieldName: "code",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "客户名称",
            fieldName: "name",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "状态",
            fieldName: "enable",
            size: "small",
            disabled: false,
            options:[{key:"0",label:"关闭",value:"0"},{key:"1",label:"开启",value:"1"}]
        }
    ]
    return (
        <YhPageHeader
            title="客户管理列表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={upDataSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    )
}